"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SearchBar = (props) => {
    const [queryString, setQueryString] = (0, react_1.useState)("");
    const [isInitialValue, setIsInitialValue] = (0, react_1.useState)(props.clearInitialValue ? true : false);
    const [_initialValue, _setInitialValue] = (0, react_1.useState)(props.value);
    const handleChange = (searchString) => {
        setQueryString(searchString);
        props.onChange(searchString);
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "form-row my-4", children: (0, jsx_runtime_1.jsxs)("div", { className: "col-12 input-group", children: [(0, jsx_runtime_1.jsx)("button", { className: "input-group-prepend a-input-clear a-input-border", type: "button", "aria-label": "Clear search and reset filters", onClick: (e) => props.onReset(e) }), (0, jsx_runtime_1.jsx)("input", { id: "query-string", className: "form-control a-input-border", type: "text", onChange: (e) => handleChange(e.target.value), value: props.value, "aria-label": "Search", onFocus: (_e) => {
                        if (props.clearInitialValue && isInitialValue) {
                            setIsInitialValue(false);
                            handleChange("");
                        }
                    }, onKeyUp: (e) => {
                        if (props.submitOnEnter && props.onSubmitEnter && e.key === "Enter")
                            props.onSubmitEnter(queryString);
                    } }), (0, jsx_runtime_1.jsx)("button", { type: "submit", onClick: (e) => props.onSubmit(e, queryString), className: "input-group-append a-input-search a-input-border", "aria-label": "Submit search" })] }) }));
};
exports.default = SearchBar;
